import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const approvalFlowStageServiceFields = `
  id
  approvalStageIsCurrentStage
  serviceStage {
    id
    stageUniqueId
    stageName
    stageIsStarting
    stageIsEnding
    stageDesignation {
      id
      designationUniqueId
      designationShortForm
      designationName
    }
  }
  approvalStageDirection
  approvalStageDate
  approvalStageComment
  approvalStageAction
  approvalStageIsRoster
  approvalStageEntryDate
  workdaysTaken
`

export const GET_APPROVAL_STAGES_ACTIONS = gql`
  query GetApprovalStageActions($serviceUniqueId: String) {
    getApprovalStageActions(serviceUniqueId: $serviceUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${approvalFlowStageServiceFields}
      }
    }
  }
`
